import { RecentReceptionsApiService } from '@src/api/recent_receptions_api.service';
import { Singleton } from '@visiba/instantiation';
import { AuthService } from './auth/auth.service';

@Singleton()
export class RegisterRecentVisitService {
	private latestVisited: number | null = null;

	constructor(
		private readonly recentReceptionsApiService: RecentReceptionsApiService,
		private readonly authService: AuthService,
	) {
		// Empty
	}

	public async dispatchLatestRegistered(): Promise<number | null> {
		if (this.latestVisited != null) {
			const latestVisited = this.latestVisited;
			this.latestVisited = null;

			await this.recentReceptionsApiService.postToRecentlyVisited(latestVisited);

			return latestVisited;
		}

		return null;
	}

	public registerVisit(receptionId: number): void {
		if (!this.authService.isAuthenticated()) {
			this.latestVisited = receptionId;

			return;
		}

		this.recentReceptionsApiService.postToRecentlyVisited(receptionId).catch(() => {
			// noop
		});
	}
}
